import React from 'react';
import { Button } from 'semantic-ui-react';
import CancelJob from '../CancelJob';

const CancelJobButton = ({ job, size = 'medium' }) => (
  <CancelJob job={job}>
    <Button size={size} basic negative>
      {`Cancel ${job.project.type === 'Interview' ? 'Meeting' : 'Survey'}`}
    </Button>
  </CancelJob>
);

export default CancelJobButton;
